import { DB_URL } from '../../util/DB_URL';
import Strapi from 'strapi-sdk-js';

const strapi = new Strapi({
  url: DB_URL,
  prefix: '/api',
});

export const GET_PRODUCTS = 'GET_PRODUCTS';
export const GET_PRODUCT_CATEGORIES = 'GET_PRODUCT_CATEGORIES';
export const SELECT_PRODUCT = 'SELECT_PRODUCT';
export const GET_PRODUCT_ATTRIBUTES = 'GET_PRODUCT_ATTRIBUTES';
export const GET_PRODUCT_OPTIONS = 'GET_PRODUCT_OPTIONS';
export const SAVE_PRODUCT_ATTRIBUTE = 'SAVE_PRODUCT_ATTRIBUTE';
export const SAVE_PRODUCT_OPTION = 'SAVE_PRODUCT_OPTION';
export const UPDATE_PRODUCT_ATTRIBUTE = 'UPDATE_PRODUCT_ATTRIBUTE';
export const SAVE_PRODUCT = 'SAVE_PRODUCT';

export function getProducts(cookie) {
  return async function (dispatch) {
    const { data } = await strapi.find('products', {
      populate: {
        product_categories: { fields: ['id', 'name'] },
        media: 'media',
      },
    });
    return await dispatch({
      type: GET_PRODUCTS,
      data: data ? data : null,
    });
  };
}

export function getCategories(cookie) {
  return async function (dispatch) {
    const { data } = await strapi.find('product-categories');
    return await dispatch({
      type: GET_PRODUCT_CATEGORIES,
      data: data,
    });
  };
}

export function selectProduct(id) {
  return async function (dispatch) {
    const { data } = await strapi.findOne('products', id, {
      populate: {
        product_categories: {
          fields: ['id', 'name'],
        },
        product_attributes: {
          populate: {
            product_options: {
              fields: ['id', 'name', 'values'],
            },
            products: {
              fields: ['id'],
            },
          },
          fields: ['id', 'name', 'parts'],
        },
        parts: {
          fields: ['id', 'name', 'breakdown'],
        },
        media: 'media',
      },
    });

    return await dispatch({
      type: SELECT_PRODUCT,
      data: data,
    });
  };
}

export function saveProduct(id, product) {
  return async function (dispatch) {
    const { data } = await strapi.update('products', id, product, {
      populate: {
        product_categories: {
          fields: ['id', 'name'],
        },
        product_attributes: {
          populate: {
            product_options: {
              fields: ['id'],
            },
            products: {
              fields: ['id'],
            },
          },
          fields: ['id', 'name', 'parts'],
        },
        parts: {
          fields: ['id', 'name', 'breakdown'],
        },
        media: 'media',
      },
    });

    return await dispatch({
      type: SAVE_PRODUCT,
      data: data,
    });
  };
}

export function updateProduct(id, product) {
  return async function (dispatch) {
    const { data } = await strapi.update('products', id, product, {
      populate: {
        product_categories: {
          fields: ['id', 'name'],
        },
        product_attributes: {
          populate: {
            product_options: {
              fields: ['id'],
            },
            products: {
              fields: ['id'],
            },
          },
          fields: ['id', 'name', 'parts'],
        },
        parts: {
          fields: ['id', 'name', 'breakdown'],
        },
        media: 'media',
      },
    });

    return await dispatch({
      type: SELECT_PRODUCT,
      data: data,
    });
  };
}

//Get all product attributes

export function getProductAttributes(cookie) {
  return async function (dispatch) {
    const { data } = await strapi.find('product-attributes', {
      populate: {
        product_options: 'product-options',
        products: {
          fields: ['id'],
        },
      },
    });

    return await dispatch({
      type: GET_PRODUCT_ATTRIBUTES,
      data: data,
    });
  };
}

//Get all product options

export function getProductOptions(id) {
  return async function (dispatch) {
    const { data } = await strapi.find('product-options', {
      filters: {
        product_attribute: {
          id: {
            $eq: id,
          },
        },
      },
    });

    return await dispatch({
      type: GET_PRODUCT_OPTIONS,
      data: data,
    });
  };
}

//Save product option

export function saveProductOption(values, id) {
  return async function (dispatch) {
    const obj = {
      ...values,
      product_attribute: id,
    };
    const { data } = await strapi.create('product-options', obj);

    return await dispatch({
      type: SAVE_PRODUCT_OPTION,
      data: data,
    });
  };
}

//save product attribute

export function createProductAttribute(cookie) {
  return async function (dispatch) {
    const { data } = await strapi.find('product-attributes', {});

    return await dispatch({
      type: SAVE_PRODUCT_ATTRIBUTE,
      data: data,
    });
  };
}

export function updateProductAttribute(attribute, product) {
  return async function (dispatch) {
    const obj = {
      ...attribute,
      products: product,
    };
    const { data } = await strapi.update(
      'product-attributes',
      attribute.existingPart?.id,
      obj
    );
    // let data;

    return await dispatch({
      type: UPDATE_PRODUCT_ATTRIBUTE,
      data: data,
    });
  };
}
